'use strict';

var superagent = require('superagent');
var createLogger = require('cf-util-logger');

var logRequest = createLogger('http:request');
var logError = createLogger('http:error');
var logSuccess = createLogger('http:success');

// Mapping of http request types to superagent methods.
var METHODS = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  PATCH: 'patch',
  DELETE: 'del'
};

// Store beforeSend callbacks.
var beforeSendCallbacks = [];

/**
 * Modify request options before they are sent.
 * Useful for authentication or other middleware.
 *
 * ```js
 * beforeSend(function(opts) {
 *   opts.url = '/api/v4' + opts.url;
 * });
 * ```
 *
 * @param {Function} callback
 */
function beforeSend(callback) {
  beforeSendCallbacks.push(callback);
}

/**
 * Perform an http request.
 *
 * ```js
 * request('POST', '/posts', {
 *   body: {
 *     title: 'A New Post',
 *     content: 'Contents of the new post.'
 *   }
 * }, function(res) {
 *   console.log(res.body); // > { result: { id: 1, title: 'A New Post', content: 'Contents of the new post.' } }
 * }, function(err) {
 *   console.log(res.body); // > { errors: [{ message: 'Error!' }] }
 * });
 * ```
 *
 * @param {String} method - GET/POST/PUT/PATCH/DELETE
 * @param {String} url
 * @param {Object} [opts]
 * @param {Object} [opts.parameters]
 * @param {Object} [opts.headers]
 * @param {Object} [opts.body]
 * @param {Function} [callback]
 * @returns {Function} Abort request.
 */
function request(method, url, opts, callback) {
  opts = opts || {};

  opts.method = method;
  opts.url = url;
  opts.callback = callback;

  // Allow beforeSend to modify request options.
  beforeSendCallbacks.forEach(function (cb) {
    return cb(opts);
  });

  // Configure request
  var req = superagent[METHODS[opts.method]](opts.url);

  if (opts.parameters) {
    req.query(opts.parameters);
  }

  if (opts.headers) {
    req.set(opts.headers);
  }

  if (opts.body) {
    req.send(opts.body);
  }

  var logMessage = opts.method + ' ' + opts.url;

  logRequest(logMessage);

  // Send request
  req.end(function (err, res) {
    logMessage = logMessage + ' (' + res.status + ' ' + res.statusText + ')';

    var result = {
      headers: res.headers,
      status: res.status,
      body: res.body,
      text: res.text
    };

    if (err) {
      logError(logMessage);
      opts.callback(result);
    } else {
      logSuccess(logMessage);
      opts.callback(null, result);
    }
  });

  // Return abort function
  return function () {
    req.abort();
  };
}

/**
 * Perform a GET request.
 */
function get() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return request.apply(undefined, ['GET'].concat(args));
}

/**
 * Perform a POST request.
 */
function post() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return request.apply(undefined, ['POST'].concat(args));
}

/**
 * Perform a PUT request.
 */
function put() {
  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return request.apply(undefined, ['PUT'].concat(args));
}

/**
 * Perform a PATCH request.
 */
function patch() {
  for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return request.apply(undefined, ['PATCH'].concat(args));
}

/**
 * Perform a DELETE request.
 */
function del() {
  for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  return request.apply(undefined, ['DELETE'].concat(args));
}

module.exports = { beforeSend: beforeSend, request: request, get: get, post: post, put: put, patch: patch, del: del };


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-util-http/lib/http.js
// module id = 664
// module chunks = 0